module.exports = __webpack_public_path__ + "static/media/addNewBusinessIcon.8b023055.svg";